/* 
    Handles the form created by clicking 'New Job Note' button on the WorkOrderForm
*/

import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Row,
  Col,
  Alert,
} from "reactstrap";
import Draggable from "react-draggable";

import { UploadFile } from "./utils/DataFetch";
import { GetCookie } from "./utils/Common";
import DeleteIcon from "../images/delete.png";

export class InterpreterItemForm extends Component {
  static displayName = InterpreterItemForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      model: props.model,
      deltaPosition: { x: 0, y: 0 },
    };
    //
    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleDeleteFile = this.handleDeleteFile.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keydownHandler);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
  }

  keydownHandler = (e) => {
    if (e.keyCode === 83 && e.altKey) {
      // Alt + S
      e.preventDefault();
      e.stopPropagation();

      this.onSave();
    }
  };

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  handleChange(e) {
    let model = { ...this.state.model };
    model[e.target.name] = e.target.value;

    this.setState({ model });
  }

  handleUploadFile(e) {
    let model = { ...this.state.model };
    model.FileName = e.target.files[0].name;
    model.FormFile = e.target.files[0];

    this.setState({ model });
  }

  handleDeleteFile() {
    this.fileUpload.value = null;

    let model = { ...this.state.model };
    model.FileName = "";
    model.FileLocation = "";

    this.setState({ model });
  }

  async onSave() {
    let model = this.state.model;

    if (model.EventType === "insert") {
      model.CreateByUserId = this.user.userid;
    } else if (model.EventType === "update") {
      model.UpdateByUserId = this.user.userid;
    }

    var formData = new FormData();
    formData.append("EventType", model.EventType);
    formData.append("IntItemId", model.IntItemId);
    formData.append("IntId", model.IntId);
    formData.append("ItemName", model.ItemName);
    formData.append("ItemDescription", model.ItemDescription);
    formData.append("Contact", model.Contact);
    formData.append("ContactEmail", model.ContactEmail);
    formData.append("Notes", model.Notes);
    formData.append("FileLocation", model.FileLocation);
    formData.append("FileName", model.FileName);
    formData.append("IntItemType", model.IntItemType);
    formData.append("CreateDateTime", model.CreateDateTime);
    formData.append("CreateByUserId", model.CreateByUserId);
    formData.append("UpdateByUserId", model.UpdateByUserId);
    formData.append("UpdateDateTime", model.UpdateDateTime);
    formData.append("IsDeletedFlg", model.IsDeletedFlg);
    formData.append("FormFile", model.FormFile);

    await UploadFile("/saveinterpreteritem", this.user.token, formData).then(
      (data) => {
        this.props.handleSaveEventSuccess({
          message: data,
          modal: data === "Success" ? false : true,
          color: data === "Success" ? "success" : "warning",
        });
      }
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;

    return (
      <Draggable
        handle=".interpreter-item-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              height: "150px",
              width: "500px",
            }}
            backdrop="static"
          >
            <ModalHeader className="interpreter-item-handle handle">
              New/Edit Interpreter Item
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <Alert
                      color={this.props.alert.color}
                      isOpen={this.props.alert.isOpen}
                    >
                      {this.props.alert.message}
                    </Alert>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: "90px" }}>
                        Type:
                      </InputGroupText>
                      <select
                        name="IntItemType"
                        value={this.state.model.IntItemType}
                        className="form-control"
                        onChange={this.handleChange}
                        disabled={
                          this.state.model?.IntItemId === null ? false : true
                        }
                      >
                        <option value="Code of Conduct">Code of Conduct</option>
                        <option value="Confidentiality Agreement">Confidentiality Agreement</option>
                        <option value="Note">Note</option>
                        <option value="Attachment">Attachment</option>
                      </select>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <InputGroupText>Description:</InputGroupText>
                      <textarea
                        name="ItemDescription"
                        value={this.state.model.ItemDescription}
                        className="form-control"
                        onChange={this.handleChange}
                      ></textarea>
                    </InputGroup>
                  </Col>
                </Row>
                {this.state.model.IntItemType === "Attachment" && <hr />}
                {this.state.model.IntItemType === "Attachment" && (
                  <Row>
                    <Col
                      className={
                        this.state.model.FileName === "" ? "col-12" : "col-11"
                      }
                      style={{ position: "relative" }}
                    >
                      <input
                        id="file"
                        type="file"
                        name="fileUpload"
                        className="form-control"
                        onChange={this.handleUploadFile}
                        ref={(ref) => (this.fileUpload = ref)}
                      />
                      <span
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "calc(100% - 24px)",
                          textAlign: "center",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          pointerEvents: "none",
                        }}
                      >
                        {this.state.model.FileName === ""
                          ? "Drag your file here!"
                          : this.state.model.FileName}
                      </span>
                    </Col>
                    <Col className="col-1">
                      <img
                        src={DeleteIcon}
                        style={{
                          width: "14px",
                          height: "14px",
                          cursor: "pointer",
                          display:
                            this.state.model.FileName === "" ? "none" : null,
                        }}
                        onClick={this.handleDeleteFile}
                        alt="Delete"
                      />
                    </Col>
                  </Row>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="dark" onClick={this.props.setModal} size="sm">
                Cancel
              </Button>
              <Button color="primary" onClick={this.onSave} size="sm">
                Save
              </Button>
              {/*<Button color="primary" onClick={() => { if (window.confirm("Are you sure to save this record?")) { this.onSave() } }} size="sm">Save</Button>*/}
            </ModalFooter>
          </Modal>
        </div>
      </Draggable>
    );
  }
}
